import { useEffect, useState, useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import Filter from "./FilterBranch";
import { FILTER_DEFINATIONS } from "./config";
import usePagination from "hooks/usePagination";
import useFilterHook from "hooks/useFilter";
import { DEFAULT_TOTAL_RECORDS } from "utils/constants";
import { fetchTatGraphicalReports } from "services/tatReport";
import { useDispatch, useSelector } from "react-redux";
import {
  getDoctorList,
  getFranchiseTypesList,
  getInvestigationList,
  getZoneList,
  getDepartmentList,
  getStatusList,
  getPackageList,
  getFranchiseList,
  getLabDepartmentList,
} from "../../redux/action/drop_list_action";
import TatGraphicalReportModal from "./TatGraphicalReportModal";

const TatGraphicalReport = () => {
  const [isAddBranchOpen, setIsAddBranchOpen] = useState(false);
  const [rowDataForEdit, setRowDataForEdit] = useState(null);
  const [isDelete, setIsDelete] = useState(-1);
  const [isDownloadingCSV, setIsDownloadingCSV] = useState(false);

  const [searchedFilters, setSearchedFilters] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState([]);

  const [searchCount, setSearchCount] = useState(0);

  const dispatch = useDispatch();

  const [isSuperFranchise] = useState(() =>
    Number(localStorage.getItem("is_super_franchise")),
  );
  const [isFranchiseEmployee] = useState(() =>
    Number(localStorage.getItem("is_franchise_employee")),
  );
  const [isSubFranchise] = useState(() =>
    Number(localStorage.getItem("sub_franchise")),
  );

  const { investigation_list, lab_department_list } = useSelector(
    (state) => state.dropListReducer,
  );

  useEffect(() => {
    dispatch(getPackageList());
    dispatch(getInvestigationList());
    dispatch(getFranchiseTypesList());
    dispatch(getDoctorList());
    dispatch(getZoneList());
    dispatch(getDepartmentList());
    dispatch(getStatusList());
    dispatch(getFranchiseList());
    dispatch(getLabDepartmentList());
  }, []);

  const {
    currentPage,
    itemPerPage,
    disablePrev,
    disableNext,
    disableFirst,
    disableLast,
    totalPages,
    updateCurrentPage,
    updateTotalRecords,
  } = usePagination();

  const { filters, updateFilter, updateMultipleFilters } = useFilterHook(
    FILTER_DEFINATIONS,
    updateCurrentPage,
  );

  const handleDepartmentChange = useCallback(
    (selectedDepartmentIds) => {
      if (selectedDepartmentIds.length > 0) {
        dispatch(getInvestigationList(selectedDepartmentIds));
      }
    },
    [dispatch],
  );

  const handleSearchSubmit = useCallback(
    (newFilters) => {
      const cleaned = newFilters;
      updateMultipleFilters(cleaned);
      setSearchedFilters(cleaned);
      setSearchCount((prev) => prev + 1);
      updateCurrentPage(1);
    },
    [updateMultipleFilters, updateCurrentPage],
  );

  const {
    data: branchData,
    isLoading,
    refetch: refetchBranches,
  } = useQuery(
    ["fetch-tat-graphical-reports", currentPage, searchedFilters, searchCount],
    () => fetchTatGraphicalReports(currentPage, searchedFilters),
    {
      enabled: searchedFilters !== null,
      keepPreviousData: false,
      staleTime: 0,
      cacheTime: 0,
      onSuccess: (res) => {
        updateTotalRecords(res?.data?.additional_data?.total_count);
        const data = res?.data || [];
        if (data.length > 0) {
          setModalData(data);
          setIsModalOpen(true);
        }
      },
      select: (res) => {
        const response = res?.data?.data;
        if (response && response.length) {
          res.data.data = response.map((x, index) => ({
            ...x,
            _index: (currentPage - 1) * DEFAULT_TOTAL_RECORDS + index + 1,
          }));
        }
        return res;
      },
      onError: (res) => {
        console.error("Error fetching TAT report:", res);
      },
    },
  );

  return (
    <div className="container-fluid mb-3">
      <div className="box mb-4">
        <div
          className="boxHeader"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h1>TAT Graphical Report</h1>
        </div>

        <div className="left d-lg-flex align-items-center">
          <Filter
            // updateFilter={updateFilter}
            filters={filters}
            updateMultipleFilters={handleSearchSubmit}
            investigation_list={investigation_list}
            lab_department_list={lab_department_list}
            onDepartmentChange={handleDepartmentChange}
          />
        </div>

        <TatGraphicalReportModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          data={modalData}
          fromDate={searchedFilters?.date_from}
          toDate={searchedFilters?.date_to}
        />
      </div>
    </div>
  );
};

export default TatGraphicalReport;
